import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
	async getHubListdetails(input) {
		try {
			let result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'external/gethubservicecenterlist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getBagShipmentDetailsByBagNumber(input) {
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getBagShipmentDetailsByBagNumber',
				'data':input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getBagDetailsByBagNo(input) {
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getbagdetailsbybagnumber',
				'data':input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getCargoShipmentDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getcargoshipmentdetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getPaperBagSummary(input) {
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getpaperbagsummary',
				'data':input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getHandoverReportDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'handover/gethandoverreport',
				data: input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getClientCommersialsDetailsforDownload(input) {
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'clientcontract/clientcommercialdetails',
				'data':input
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async downloadClientTatReport(input) {
        try {
            let result = await axios({
                method: 'POST',
                url: apiUrl.api_url + 'clientcontract/downloadClientTatReport',
                'data':input
            })
            return result;
        } catch (err) {
            throw new Error(err);
        }
    };
	async getCargoParentShipmentDetails(input){
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getcargoparentshipmentdetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getInvoiceDetails(input){
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getinvoicedetailsforbagshipment',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getPODDetails(input){
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getpoddetailsforbagshipment',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getEBNDetails(input){
		try {
			let result = await axios({
				method: 'POST',
				url: apiUrl.api_url + 'bagshipmentquery/getebndetailsforbagshipment',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getLatLongDetailsAgainstParentAwb(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'bagshipmentquery/getlatlongdetailsagainstparentawb',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async getprintmpslogs(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'printstickerlogs/getprintmpslogs',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error("Print mps logs data not found");
		}
	};
	async getprintawblogs(input) {
		try {
			let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'printstickerlogs/getprintawblogs',
			'data': input,
			})
			return result;
		} catch (err) {
			throw new Error("Print awb logs data not found");
		}
	};
	async printawblogs(input) {
		try {
			let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'printstickerlogs/printawblogs',
			'data': input,
			})
			return result;
		} catch (err) {
			throw new Error("Print AWB logs not inserted");
		}
	};
	async getpincodelogs(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'printstickerlogs/getpincodelogs',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error("Pincode logs data not found");
		}
	};
	async getupdatepartblogs(input) {
		try {
			let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'printstickerlogs/getupdatepartblogs',
			'data': input,
			})
			return result;
		} catch (err) {
			throw new Error("Part B logs data not found");
		}
	};
	async getLmHandoverLog(input) {
		try {
			let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'handover/getlmhandoverlog',
			'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getLmHandoverLogDownload(input) {
		try {
			let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'handover/getlmhandoverlogdownload',
			'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
}



// WEBPACK FOOTER //
// ./src/modules/report/services/report.service.js